<template>
    <component :is="component" :activityId="activityId"></component>
</template>

<script>
import RomaFormPreviewActivity from "@/components/activity/RomaFormPreviewActivity";
export default {
    data() {
        return {
            component: RomaFormPreviewActivity
        };
    },
    mounted() {
        console.log(this.activityId);
    },
    computed: {
        activityId() {
            return this.$route.params.id ? this.$route.params.id : "";
        }
    }
};
</script>

<style></style>
